<div class="result-card">
   <div class="result-card__header">
      <div
         class="result-card__image bg-gray-light bg-center bg-contain bg-no-repeat
         {{ !headerImage ? 'bg-user-placeholder' : '' }}"
      >
         <img
            *ngIf="headerImage"
            class="w-full h-full object-cover"
            [src]="headerImage"
            (error)="handleImageError($event)"
         />
      </div>
   </div>
   <div class="result-card__body">
      <ng-content></ng-content>
   </div>
</div>

